module.exports = __webpack_public_path__ + "img/d_v4.75a08b4.png";